import { i18HashMapKey } from '../../Utility/constant';
import * as actionType from './type';

const getInitialHashMap = () => {
    const STORAGE_KEY = i18HashMapKey;
    try {
        if (typeof window !== 'undefined' && window.localStorage) {
            const cached = localStorage.getItem(STORAGE_KEY);
            if (cached) {
                const parsed = JSON.parse(cached);
                if (parsed && typeof parsed === 'object' && !Array.isArray(parsed) && Object.keys(parsed).length > 0) {
                    return parsed;
                }
                localStorage.removeItem(STORAGE_KEY);
            }
        }
    } catch {
        try {
            if (typeof window !== 'undefined' && window.localStorage) {
                localStorage.removeItem(STORAGE_KEY);
            }
        } catch {
        }
    }
    return {};
};

const initialState = {
    isLoading: false,
    clientLabelData : [],
    currentHashMapData: getInitialHashMap(),
}

export default function (state = initialState, action) {
    switch(action.type) {
        case actionType.RECEIVED_GLOBALIZE_DATA: {
            return {
                ...state,
                clientLabelData: action?.payload?.data,
                currentHashMapData: action?.payload?.currentHashMapData,
                isLoading: false
            }
        }

        case actionType.REQUEST_UPDATE_HASH_MAP: {
            return {
                ...state,
                currentHashMapData: action?.payload
            }
        }

        case actionType.REQUEST_GLOBALIZE_DATA: {
            return {
                ...state,
                isLoading: action?.payload
            }
        }


        default: {
            return state;
        }
    }
}